export interface IEpletMismatch {
    geneGroupId: number;
    geneGroup: string;
    name: string;
    hasAntibodyReactivity: boolean;
    residue: string;
    foundIn: string;
    notes: null | string;
}